import React from 'react'
import './note-fall-2023.css'
import { MdMoreVert } from 'react-icons/md'
import axios from 'axios'
import { baseUrl } from '../../../assets/Animations'
import NoteDropdownMenu from './NoteDropdownMenu/NoteDropdownMenu'

const NoteFall2023 = (props) => {
    const [teacherImageUrl, setTeacherImageUrl] = React.useState('')
    const [openMenu, setOpenMenu] = React.useState(false)

    React.useEffect(() => {
        if(props.note.connections.length > 0) {
            props.note.connections.forEach(connection => {
                connection.type === 'teacherId' && getTeacherImageUrl(props.note.connections[0].displayName) 
            });
        }
    })


    const getTeacherImageUrl = async (name) => {
        axios.get(`${baseUrl}/teacherimageurl/${name.replace(/\s/g, '=')}`)
        .then((res) => {
            setTeacherImageUrl(res.data.ImageName)
        })
        .catch((err) => {
            console.log(err)
        })
    }


    return(
        <div className='admin-note-fall-2023' style={props.note.important ? {border: '2px solid red'} : {border: 'none'}}>
            <div className='admin-note-fall-2023__top-section'>
                <img className='admin-note-fall-2023-admin-image' alt='author-pic' src={`https://app.atharo.app/${props.note.author.toLowerCase().replace(/\s/g, '')}.jpg`}/>
                <div className='admin-note-fall-2023__top-section__text-wrapper'>
                    <div className='admin-note-fall-2023__name'>{props.note.author.split(' ')[0]}</div>
                    <div className='admin-note-fall-2023__date'>{new Date(props.note.date).getMonth() + 1}/{new Date(props.note.date).getDate()}/{new Date(props.note.date).getFullYear()}</div>
                </div>
                {props.userData.Name === props.note.author ? <MdMoreVert className='admin-note-fall-2023__edit-note-dots' color='#94A3B8' onClick={() => setOpenMenu(!openMenu)} /> : <div></div>}
                {openMenu && <NoteDropdownMenu 
                    setOpenMenu={setOpenMenu} 
                    editNote={() => props.setEditNote(props.note)}
                    deleteAndRemoveNote={() => props.deleteAndRemoveNote(props.note)}
                    note={props.note}
                    updateAndReplaceNote={props.updateAndReplaceNote}
                    />}
            </div>
            <div className='admin-note-fall-2023__details'>{props.note.details}</div>
            <div className='admin-note-fall-2023__connections__wrapper'>
                {props.note.connections.map((connection, index) => 
                    <div key={index} className='admin-note-fall-2023__connection__wrapper'>
                        {connection.type === 'teacherId' && <img alt='connection-teacher' src={`https://app.atharo.app/images/${teacherImageUrl}`} className='admin-note-fall-2023__connection__image' />}
                        <div className='admin-note-fall-2023__connection__name'>{connection.type === 'teacherId' ? connection.displayName : `${connection.displayName} Family`}</div>
                    </div>
                )}
            </div>
        </div>
    )
}
export default NoteFall2023